const Location = {
  INTERIOR: 0,
  EXTERIOR: 1,
};

export default Location;
